import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import { Formik } from "formik";
import React, { useState } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { object, string } from "yup";
import DropdownCmp2 from "../../../components/dropdown/DropdownCmp2";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import { RegisterUserRequest } from "../../../models/security.model";
import { RegisterUser } from "../../../services/security.service";
import SwitchCmp from "../../../components/switch/SwitchCmp";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import {
  DefaultPassword,
  getPassword,
} from "../../../redux/permissions/permissonSlice";

interface Props {
  openAddUserModal: boolean;
  setOpenAddUserModal: any;
}
const userValidation = object().shape({
  firstName: string()
    .ensure()
    .required("لطفا نام را وارد نمایید.")
    .max(150, "نام نباید بیش از ۱۵۰ کاراکتر باشد"),
  lastName: string()
    .ensure()
    .required("لطفا نام خانوادگی را وارد نمایید.")
    .max(150, "نام خانوادگی نباید بیش از ۱۵۰ کاراکتر باشد"),
  username: string()
    .ensure()
    .required("نام کاربری را وارد نمایید")
    .max(150, "نام کاربری نباید بیش از ۱۵۰ کاراکتر باشد"),
  mobileNumber: string().test(
    "length-check",
    "شماره موبایل را صحیح وارد نمایید",
    function(value) {
      if (!value) return true;
      return value.length === 11;
    }
  ),
});
const genderOptions = [
  { title: "مرد", id: 1, enumData: "Male" },
  { title: "زن", id: 2, enumData: "Female" },
];
const userTypeOptions = [
  { title: "سیستمی", id: 1, enumData: "true" },
  { title: "غیر سیستمی", id: 2, enumData: "false" },
];
const activeStateOptions = [
  { title: "فعال", id: 1, enumData: "true" },
  { title: "غیر فعال", id: 2, enumData: "false" },
];

const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: 500,
  },
  maxWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: 500,
  },

  maxHeight: "70vh",
  minHeight: "30vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  // overflow: "auto",
  // overflowX: "hidden",
  // paddingRight: "3vh",
  paddingTop: "4vh",
  // direction: "ltr",
  borderRadius: "5px",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

const AddUserModal = ({ openAddUserModal, setOpenAddUserModal }: Props) => {
  const [genderValue, setGenderValue] = useState<"Male" | "Female">();
  const [userTypeValue, setUserTypeValue] = useState<any>();
  const [activeStateValue, setActiveStateValue] = useState<any>();
  const [admin, setAdmin] = useState<boolean>();
  const [defaultPassword, setDefaultPassword] = useState("");

  const dispatch = useDispatch();

  const handleSelectedGenderDrop = (e: any) => {
    setGenderValue(e.target.value);
  };
  const handleSelectedUserTypeDrop = (e: any) => {
    setUserTypeValue(e.target.value);
  };
  const handleSelectedActiveStateDrop = (e: any) => {
    setActiveStateValue(e.target.value);
  };
  const history = useHistory<{ permissionUserId: number }>();
  const initialValues: RegisterUserRequest = {
    firstName: "",
    lastName: "",
    username: "",
    mobileNumber: undefined,
    gender: "Male",
    isSystemUser: false,
    notificationEnabled: false,
  };

  const { mutate: RegisterUserMutate } = useMutation(RegisterUser, {
    onSuccess: (data: { userId: number; password: string }) => {
      if (data) {
        setOpenAddUserModal(false);
        history.push({
          pathname: "/userDetail",
          state: { permissionUserId: data.userId },
        });
        // toast.success(`کلمه عبور پیشفرض این کاربر ${data.password} است`);
        dispatch(
          getPassword({
            password: data.password,
          })
        );
      }
    },
    onError: () => {},
  });

  const handleFormSubmit = (values: RegisterUserRequest) => {
    RegisterUserMutate({
      firstName: values.firstName,
      lastName: values.lastName,
      username: values.username,
      gender: genderValue!,
      isSystemUser: userTypeValue === "true" ? true : false,
      notificationEnabled: activeStateValue === "true" ? true : false,
      mobileNumber:
        values.mobileNumber === "" ? undefined : values.mobileNumber,
      isAdmin: admin,
    });
  };

  return (
    <>
      <Modal
        open={openAddUserModal}
        onClose={() => {
          setOpenAddUserModal(false);
          setActiveStateValue("");
          setUserTypeValue("");
          setGenderValue(undefined);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={deactiveUserStyle}>
          <Grid
            container
            flexDirection={"column"}
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={"2rem"}
          >
            <Grid item>
              <Typography
                component={"p"}
                display={"block"}
                textAlign={"center"}
                // marginY={"3rem"}
                // fontSize={"44px"}
              >
                <AccountCircleIcon
                  sx={{ fontSize: "64px", color: "#9AAFC4" }}
                />
              </Typography>
            </Grid>
            <Formik
              initialValues={initialValues}
              onSubmit={handleFormSubmit}
              validateOnMount={true}
              validationSchema={userValidation}
              validateOnChange={false}
              validateOnBlur={true}
            >
              {({
                handleSubmit,
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
              }) => (
                <Grid item sx={{ width: "100%" }}>
                  <form onSubmit={handleSubmit}>
                    <Grid
                      container
                      gap={"2rem"}
                      justifyContent={"center"}
                      alignItems={"center"}
                    >
                      <Grid item xs={12}>
                        <MaterialTextFieldComponent
                          // sx={{ maxWidth: "400px" }}
                          placeHolder={"نام"}
                          label={"نام"}
                          required={true}
                          name="firstName"
                          id="firstName"
                          helperText={touched.firstName ? errors.firstName : ""}
                          error={touched.firstName && Boolean(errors.firstName)}
                          onChange={handleChange}
                          value={values.firstName}
                          onBlur={handleBlur}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <MaterialTextFieldComponent
                          // sx={{ maxWidth: "400px" }}
                          placeHolder={"نام خانوادگی"}
                          label={"نام خانوادگی"}
                          required={true}
                          name="lastName"
                          id="lastName"
                          helperText={touched.lastName ? errors.lastName : ""}
                          error={touched.lastName && Boolean(errors.lastName)}
                          onChange={handleChange}
                          value={values.lastName}
                          onBlur={handleBlur}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <MaterialTextFieldComponent
                          // sx={{ maxWidth: "400px" }}
                          placeHolder={"شماره موبایل"}
                          label={"شماره موبایل"}
                          name="mobileNumber"
                          id="mobileNumber"
                          helperText={
                            touched.mobileNumber ? errors.mobileNumber : ""
                          }
                          error={
                            touched.mobileNumber && Boolean(errors.mobileNumber)
                          }
                          onChange={handleChange}
                          value={values.mobileNumber}
                          onBlur={handleBlur}
                          onKeyDown={(e) => {
                            if (/^(?![0-9]).*$/.test(e.key)) {
                              if (e.code !== "Backspace")
                                if (e.code !== "Delete") e.preventDefault();
                            }
                          }}
                          inputProps={{ maxLength: 11 }}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <MaterialTextFieldComponent
                          // sx={{ maxWidth: "400px" }}
                          placeHolder={"نام کاربری"}
                          label={"نام کاربری"}
                          required={true}
                          name="username"
                          id="username"
                          helperText={touched.username ? errors.username : ""}
                          error={touched.username && Boolean(errors.username)}
                          onChange={handleChange}
                          value={values.username}
                          onBlur={handleBlur}
                          onKeyDown={(e) => {
                            if (
                              /^[آ-ی ء چ]+$/.test(e.key) &&
                              e.code !== "Space"
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sx={{ display: "flex", gap: "1.5rem" }}
                      >
                        <Grid
                          item
                          maxWidth={209}
                          //  sx={{ paddingLeft: "10px" }}
                          className="dropdownCmp2-container"
                        >
                          <DropdownCmp2
                            style={
                              {
                                // maxWidth:
                                //   orederStateValue === "DeliveredToCustomer"
                                //     ? "500px"
                                //     : "300px",
                              }
                            }
                            onChange={handleSelectedGenderDrop}
                            value={genderValue}
                            label={"جنسیت*"}
                            options={genderOptions}
                            name="gender"
                            id="gender"
                            darkTheme={true}
                            // defaultValue={dafaultDropdownValue}
                          />
                        </Grid>
                        <Grid
                          item
                          //  sx={{ paddingRight: "10px" }}
                          maxWidth={209}
                          className="userHeader-dropdown dropdownCmp2-container"
                        >
                          <DropdownCmp2
                            // style={{
                            //   maxWidth: "400px",
                            // }}

                            onChange={handleSelectedUserTypeDrop}
                            value={userTypeValue}
                            label={"نوع کاربر*"}
                            options={userTypeOptions}
                            name="userType"
                            id="userType"
                            darkTheme={true}
                            // defaultValue={dafaultDropdownValue}
                          />
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sx={{ display: "flex", gap: "1.5rem" }}
                      >
                        <Grid
                          item
                          maxWidth={209}
                          //  sx={{ paddingLeft: "10px" }}
                          className="dropdownCmp2-container"
                        >
                          <DropdownCmp2
                            style={{
                              paddingRight: "0 !important",
                              // maxWidth: "400px",
                            }}
                            onChange={handleSelectedActiveStateDrop}
                            value={activeStateValue}
                            label={"دریافت اطلاعیه*"}
                            options={activeStateOptions}
                            name="activeState"
                            id="activeState"
                            darkTheme={true}
                            // defaultValue={dafaultDropdownValue}
                          />
                        </Grid>
                        <Grid
                          item
                          maxWidth={209}
                          className="certificate-switch"
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <SwitchCmp
                            Label={"ادمین"}
                            checked={admin === false}
                            onChange={(checked: boolean) => {
                              setAdmin(checked);
                            }}
                            onlabel={"بله"}
                            offlabel={"خیر"}
                            colSize="col-lg-6 col-6"
                          />
                        </Grid>
                      </Grid>
                      <Grid item width={"100%"}>
                        <Grid
                          container
                          flexDirection={"row"}
                          justifyContent={"center"}
                          gap={"1rem"}
                        >
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={6}
                            maxWidth={"150px !important"}
                          >
                            <Button
                              fullWidth
                              variant="contained"
                              type="submit"
                              disabled={
                                !values.firstName ||
                                !values.lastName ||
                                !values.username ||
                                // !values.mobileNumber ||
                                !genderValue ||
                                !userTypeValue ||
                                !activeStateValue
                              }
                              className={
                                !values.firstName ||
                                !values.lastName ||
                                !values.username ||
                                // !values.mobileNumber ||
                                !genderValue ||
                                !userTypeValue ||
                                !activeStateValue
                                  ? "btnForm disabledBtn"
                                  : "btnForm SuccessDefault"
                              }
                            >
                              ثبت
                            </Button>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={6}
                            maxWidth={"150px !important"}
                          >
                            <Button
                              fullWidth
                              variant="contained"
                              style={{
                                fontSize: "1rem",
                                color: "#fff",
                                height: "40px",
                                background: "#607D8B",
                              }}
                              onClick={() => {
                                setOpenAddUserModal(false);
                                setActiveStateValue("");
                                setUserTypeValue("");
                                setGenderValue(undefined);
                              }}
                            >
                              انصراف
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                </Grid>
              )}
            </Formik>
          </Grid>
        </Box>
      </Modal>
    </>
  );
};

export default AddUserModal;
